import { Pencil, X } from "lucide-react";
import { RelationTemplateProps } from "./view-component-renderer";

export const TitleAndDescription: React.FC<RelationTemplateProps> = ({
  config,
  onRemove,
  onEdit,
}) => {
  return (
    <div>
      <div className="group flex items-center justify-between rounded-md border border-input px-3 py-2 text-sm">
        <div className="flex-grow">
          <div className="font-bold">{config.title}</div>
          {config.description && (
            <p className="line-clamp-2 whitespace-pre-wrap">{config.description}</p>
          )}
        </div>
        <div className="flex gap-2">
          <button type="button" onClick={onEdit} className="opacity-0 group-hover:opacity-100">
            <Pencil className="h-3 w-3 text-muted-foreground" />
          </button>
          <button type="button" onClick={onRemove} className="opacity-0 group-hover:opacity-100">
            <X size={"1rem"} className="text-neutral-600" />
          </button>
        </div>
      </div>
    </div>
  );
};
